import React from "react";
import "./footer.css";
import { MDBFooter, MDBContainer, MDBCol, MDBRow, MDBIcon, MDBBtn } from "mdb-react-ui-kit";

const Footer = () => {
  return (
    <MDBFooter className="bg-light text-center text-white">
      <MDBContainer className="pt-4">
        <section className="mb-4">
          <MDBBtn
            rippleColor="dark"
            color="link"
            floating
            size="lg"
            className="text-dark m-1"
            href="https://web.facebook.com/profile.php?id=61560487472636"
            role="button"
            target="_blank"
          >
            <MDBIcon fab className="fab fa-facebook-f" />
          </MDBBtn>

          <MDBBtn
            rippleColor="dark"
            color="link"
            floating
            size="lg"
            className="text-dark m-1"
            href="https://x.com/educentralng"
            role="button"
            target="_blank"
          >
            <MDBIcon fab className="fa-twitter" />
          </MDBBtn>

          <MDBBtn
            rippleColor="dark"
            color="link"
            floating
            size="lg"
            className="text-dark m-1"
            href="https://www.instagram.com/educantralng"
            role="button"
            target="_blank"
          >
            <MDBIcon fab className="fa-instagram" />
          </MDBBtn>
        </section>
      </MDBContainer>
      <div
        className="text-center p-3 text-black bg-light footer-copyright"
        style={{ backgroundColor: "bg-light" }}
      >
        © 2024 by:&nbsp;
        <a className="text-black" href="https://edu-central.org/">
          eduCentral
        </a>
      </div>
    </MDBFooter>
  );
};

export default Footer;
